/**
 * Work ID status definitions
 *
 * NEW       – Work IDs submitted by non-supervisors
 * APPROVED  – Work IDs submitted by Supervisors or approved in the system
 * ASSIGNED  – Approved Work IDs attached to a non-closed Task
 * CLOSED    – Approved Work IDs attached to a closed/finalized Task
 * CLOSED_WITHOUT_ACTION – Low/Medium priority closed by supervisor without a task
 * CANCELLED
 * MERGED
 */
export const WorkIdStatus = {
  NEW: 'NEW',
  APPROVED: 'APPROVED',
  ASSIGNED: 'ASSIGNED',
  CLOSED: 'CLOSED',
  CLOSED_WITHOUT_ACTION: 'CLOSED_WITHOUT_ACTION',
  CANCELLED: 'CANCELLED',
  MERGED: 'MERGED',
} as const;

export type WorkIdStatusType = (typeof WorkIdStatus)[keyof typeof WorkIdStatus];

export const WORK_ID_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: WorkIdStatus.NEW, label: 'New' },
  { value: WorkIdStatus.APPROVED, label: 'Approved' },
  { value: WorkIdStatus.ASSIGNED, label: 'Assigned' },
  { value: WorkIdStatus.CLOSED, label: 'Closed' },
  { value: WorkIdStatus.CLOSED_WITHOUT_ACTION, label: 'Closed without action' },
  { value: WorkIdStatus.CANCELLED, label: 'Cancelled' },
  { value: WorkIdStatus.MERGED, label: 'Merged' },
];

const STATUS_LABELS: Record<string, string> = {
  NEW: 'New',
  APPROVED: 'Approved',
  ASSIGNED: 'Assigned',
  CLOSED: 'Closed',
  CLOSED_WITHOUT_ACTION: 'Closed without action',
  CANCELLED: 'Cancelled',
  MERGED: 'Merged',
};

export function formatWorkIdStatus(status: string | null | undefined): string {
  if (!status) return '-';
  return STATUS_LABELS[status.toUpperCase()] ?? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}

// Badge colour used to live here as getWorkIdStatusBadgeVariant — a second status→colour map
// that drifted from the shared one. Callers now render through <StatusBadge vocabulary="workId">
// (see utils/statusUtils.ts), which is the single source of truth for status colour app-wide.
